import { AppService } from '../../../../app.service';
import { Component, OnDestroy, OnInit, ViewChild, Input, ElementRef, ChangeDetectorRef } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/observable/fromEvent';
import { Subscription, ISubscription } from 'rxjs/Subscription';
import { DashboardService } from '../../dashboard.service';
import { equipmentVwMdl, SearchItem, Side, ComponentTableInspectionViewModel, ComponentViewViewModel, ComponentType, ComponentActionViewModel } from '../../../../entities';
import { AppUris } from '../../../../entities/app-config/model';
import { CurrentSelection, UserSelectedIds } from '../../../../entities/global/model';
import { TranslateService } from '../../../../translate';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from "@angular/common";
import { trigger, style, animate, transition } from '@angular/animations';
import { PreferencesService } from '../../../../modules/preferences/preferences.service';
import { DataSource } from '@angular/cdk/table';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';

export enum TableView {
    EquipmentView = 0,
    ComponentView = 1
}
export enum SearchMode {
    Single = 0,
    Multiple = 1
}
export class OutstantingActionStatus {
    public ComponentId: number = 0;
    public ActionType: number = 0;
    public ActionTitle: string = '';
    public ActionStatus: string = '';
    public CssClass: string = '';
}

export enum ComponentColumnHeader {
    Sides = 0,
    Link = 1,
    HoursOnLink = 2,
    Bush = 3,
    BushTurned = 4,
    Shoe = 5,
    FrontIdler = 6,
    RearIdler = 7,
    Sprocket = 8,
    CarrierRollerAvg = 9,
    TrackRollerAvg = 10,
    TrackRollerWorst = 11,
    OutstandingActions = 12
}

@Component({
    selector: 'fleet-view-print',
    templateUrl: './fleet-view-print.component.html',
    styleUrls: ['./fleet-view-print.component.scss'],
  animations: [
    trigger(
      'fadeInOut', [
        transition(':enter', [
          style({ opacity: 0 }),
          animate('500ms', style({ opacity: 1 }))
        ]),
        transition(':leave', [
          style({ opacity: 1 }),
          animate('500ms', style({ opacity: 0 }))
        ])
      ]
    )]
})
export class FleetViewPrintComponent implements OnInit, OnDestroy {
    equipmentDataLoading: boolean = true;
    @Input() UriConfig: AppUris;
    _currentSelection: CurrentSelection = new CurrentSelection();
    _currentSearchItemSelection: SearchItem[] = [];
    _loading: number = 0;
    selectionSubscription: Subscription;
    selectionSearchItemsSubscription: Subscription;
    translateSubscription: Subscription;
    equipmentViewListBySearchItemsSubscription: Subscription;
    getEquipmentListByConditionSubscription: Subscription;
    getEquipmentCountByConditionSubscription: Subscription;
    routeSubscription: ISubscription;
    userLanguage: string = "english";
    _tableView: TableView = TableView.EquipmentView;
    displayedColumns = ['modelImage', 'EvalL', 'EvalR', 'customer', 'serial', 'unit', 'make', 'model', 'family', 'smu', 'ltd', 'lastInspectionDate', 'nextInspection'];
    equipmentList: equipmentVwMdl[] = [];
    eqTableDatabase: EqTableDatabase | null;
    dataSource: EqTableDataSource | null;
    _equipmentRequestToken = 0;
    _componentRequestToken = 0;
    componentDisplayedColumns = ['Unit', 'Model', 'Site', 'CurrentSMU', 'LastInspectionDate', 'LastInspectionSMU', 'NextInspectionSMU', 'sides', 'Link', 'HoursOnLink', 'Bush', 'BushTurned', 'Shoe', 'FrontIdler', 'RearIdler', 'Sprocket', 'CarrierRollerAVG', 'TrackRollerAVG', 'TrackRollerWorst', 'OutstandingActions'];
    equipmentComponentViewList: ComponentTableInspectionViewModel[] = [];
    componentViewDatabase: ComponentViewTableDatabase | null;
    componentViewDataSource: ComponentViewTableDataSource | null;
    _minDate: Date = new Date(1900, 1);
    _searchMode: SearchMode = SearchMode.Single;

    viewingEquipmentDetails: boolean = false;
    @ViewChild('paginator') paginator: MatPaginator;
    @ViewChild('componentPaginator') componentPaginator: MatPaginator;
    @ViewChild('filter') filter: ElementRef;
    @ViewChild(MatSort) sort: MatSort;
    loadSize: number = 25;
    loadingPage: number = 1;
    searchCount: number = 0;
    _printId: number = 0;
    _currentSort: Sort = { active: 'lastInspectionDate', direction : 'desc' };
    filterVisible: boolean = false;
    @Input() routeItemId: number;
    selectedEquipmentId: number = 0;
    selectedEquipmentRow: equipmentVwMdl = new equipmentVwMdl();

    subscriptions: Subscription[] = [];

    constructor(private _location: Location, private _route: ActivatedRoute, private _router: Router, private _moduleService: DashboardService,
        private _appService: AppService, private ref: ChangeDetectorRef,
        private _translate: TranslateService,
        private readonly _pref: PreferencesService,) {
    }
    ngOnInit() {
        if (this._route.snapshot.params.printId != null)
            this._printId = this._route.snapshot.params.printId;
        //this.routeSubscription = this._location.subscribe(l => {
        //  console.log('_location.subscribe', l);
        //  var page = l.url.split("/");
        //  this.retrieveEquipmentsBySearchItems(Number(page[2]) + 1, this.loadSize);
        //});
        this._appService.setPageTitle('Dashboard | Fleet Overview');
        this.subscriptions.push(this._translate._getPrefLang().subscribe(lang => setTimeout(() => { this.updateUserLang(lang); }, 10)));
        this._currentSelection = this._appService.getLastSelection();
        this._currentSearchItemSelection = this._appService.getLastSelectionSearchItems();

        this.subscriptions.push(this._appService.getSelection().subscribe(message => setTimeout(() => { this.selectionChangedDetected(message); }, 10)));
        this.subscriptions.push(this._appService.getSelectionSearchItems().subscribe(message => setTimeout(() => { this.selectionSearchItemChangedDetected(message); }, 10)));

        this.eqTableDatabase = new EqTableDatabase(this.equipmentList);
        this.dataSource = new EqTableDataSource(this.eqTableDatabase, this.paginator);

        this.componentViewDatabase = new ComponentViewTableDatabase(this.equipmentComponentViewList);
        this.componentViewDataSource = new ComponentViewTableDataSource(this.componentViewDatabase, this.componentPaginator);

        //this.retrieveEquipmentsBySearchItems(this.loadingPage, this.loadSize);
        /*Observable.fromEvent(this.filter.nativeElement, 'keyup')
            .debounceTime(150)
            .distinctUntilChanged()
            .subscribe(() => {
                if (!this.dataSource) { return; }
                this.dataSource.filter = this.filter.nativeElement.value;
            });*/
        this.retrieveEquipmentsByPrintId(1, 9999);
    }

    toggleView(event: any) {
        if (event.value == this._tableView)
            return;
        this._tableView = event.value;

        //if (this._tableView == TableView.EquipmentView) {
        //    this._componentRequestToken = 0;
        //    this._equipmentRequestToken = 0;
        //    this.retrieveEquipmentsBySearchItems(1, this.loadSize);
        //} else {
        //    this._componentRequestToken = 0;
        //    this._equipmentRequestToken = 0;
        //    this.retrieveEquipmentsComponentViewBySearchItems(1, this.loadSize);
        //}
    }
    ngOnDestroy() {
        if (this.routeSubscription != null)
          this.routeSubscription.unsubscribe();

        this.subscriptions.forEach(subscription => {
          if (!subscription.closed) subscription.unsubscribe();
        });
    }

    handleHideDetails(visible: boolean) {
        this.viewingEquipmentDetails = visible;
    }

    updateUserLang(lang: string) {
        this.userLanguage = lang;
        this.ref.detectChanges();
    }

    Translate(value: string): string {
        return this._translate.translateToLang(value, this.userLanguage);
    }

    cancelSearch() {
        if (this.equipmentViewListBySearchItemsSubscription != null)
            this.equipmentViewListBySearchItemsSubscription.unsubscribe();
        if (this.getEquipmentListByConditionSubscription != null)
            this.getEquipmentListByConditionSubscription.unsubscribe();
        if (this.getEquipmentCountByConditionSubscription != null)
            this.getEquipmentCountByConditionSubscription.unsubscribe();
        this._loading = 0;
    }

    pageChanged(event: PageEvent) {
        //console.log(event);
        //this.cancelSearch();
        //this.retrieveEquipmentsBySearchItems(event.pageIndex + 1, event.pageSize);
        //this._router.navigate(['fleet', (event.pageIndex + 1)]);
    }
    getNextInspectionCSSClass(dateStr: string): string {
        return this._moduleService.getNextInspectionCSSClass(dateStr);
    }
    componentPageChanged(event: PageEvent) {
        //console.log(event);
        this.retrieveEquipmentsComponentViewBySearchItems(event.pageIndex + 1, event.pageSize);
    }
    selectionChangedDetected(current: CurrentSelection) {
        if (this._loading != 0) {
            return;
        }
        this._currentSelection = current;
        this._searchMode = SearchMode.Single;
        this.retrieveEquipmentsByCondition(1, this.loadSize);
    }

    selectionSearchItemChangedDetected(current: SearchItem[]) {
        this.cancelSearch();
        this._router.navigate(['fleet', 1]);
    //    this._pref.GetReplaceExistingTabStatus().subscribe(res=>{
    //     if(res=="True"){
    //         this._router.navigate(['fleet', 1]);
    //     }else{             
    //       window.open('/fleet/' + 1, '_blank');
         
    //     }
    // });
        /*if (this._loading != 0) {

            return;
        }*/
        this._currentSearchItemSelection = current;
        this._searchMode = SearchMode.Multiple;
        //if (this._tableView == TableView.EquipmentView)
        //    this.retrieveEquipmentsBySearchItems(1, this.loadSize);
        //else
        //    this.retrieveEquipmentsComponentViewBySearchItems(1, this.loadSize);
    }

    retrieveEquipmentsByCondition(pageNo: number, pageSize: number) {
        let userSelectedParam = new UserSelectedIds();
        this.equipmentList = [];
        this.eqTableDatabase.dataChange.next(this.equipmentList);

        userSelectedParam.CustomerId = this._currentSelection.customer.Id;
        userSelectedParam.JobSiteId = this._currentSelection.jobSite.Id;
        userSelectedParam.EquipmentId = this._currentSelection.equipment.Id;
        userSelectedParam.MakeId = this._currentSelection.make.Id;
        userSelectedParam.FamilyId = this._currentSelection.family.Id;
        userSelectedParam.ModelId = this._currentSelection.model.Id;
        this._loading++;
        this.subscriptions.push(this._moduleService.getEquipmentCountByCondition(userSelectedParam).subscribe(counts => {
            this._loading++;
            this.subscriptions.push(this._moduleService.getEquipmentListByCondition(pageNo, pageSize, userSelectedParam).subscribe(result => {
                this.equipmentList.push(...result);
                this.eqTableDatabase.dataChange.next(this.equipmentList);
                this.paginator.length = counts;
                this.paginator.pageIndex = pageNo - 1;
                this.paginator.pageSize = pageSize;
                this.loadSize = pageSize;
                this.ref.detectChanges();
            }, error => { console.log(error); this._loading--; }, () => { this._loading--; }));
        }, error => { console.log(error); this._loading--; }, () => { this._loading--; }));
    }


    retrieveEquipmentsByPrintId(pageNo: number, pageSize: number) {
        this.loadingPage = pageNo;
        this.equipmentList = [];
        this.eqTableDatabase.dataChange.next(this.equipmentList);
        this._loading++;
        this._equipmentRequestToken++;
        this._moduleService.sendIsPrint(true);
        this.subscriptions.push(this._moduleService.getEquipmentViewListByPrintId(this._printId)
            .subscribe(result => {
                this.equipmentList.push(...result.ResultList);
                this.eqTableDatabase.dataChange.next(this.equipmentList);
                this.paginator.length = result.SearchResult.Total;
                this.paginator.pageIndex = pageNo - 1;
                this.paginator.pageSize = pageSize;
                //console.log('equipment paginator:', this.paginator);
                this.loadSize = pageSize;
                this.ref.detectChanges();
                this.equipmentDataLoading = false;
                setTimeout(() => {
                    this._moduleService.UpdatePrintItem(this._printId, document.documentElement.innerHTML, "").subscribe(success => {
                        if (success) {
                          //  window.location.href = 'Api/Print/FleetView/' + this._printId;
                        } else {
                            alert('Something went wrong! please try again');
                        }
                    }, error => console.error(error), () => { });
                }, 10);
            }, error => { console.log(error); this._loading--; this.equipmentDataLoading = false; }, () => { this._loading--; this.equipmentDataLoading = false; }));
    }

    retrieveEquipmentsComponentViewBySearchItems(pageNo: number, pageSize: number) {
        this.loadingPage = pageNo;
        this.cancelSearch();
        this.equipmentComponentViewList = [];
        this.componentViewDatabase.dataChange.next(this.equipmentComponentViewList);
        this._loading++;
        this._componentRequestToken++;
        this.subscriptions.push(this._moduleService.getComponentViewListBySearchItems(pageNo, pageSize, this._currentSearchItemSelection, this._componentRequestToken, this._currentSort.active, this._currentSort.direction)
            .subscribe(result => {
                if (result._clientReqId != this._componentRequestToken) {
                    console.error('Operarion Cancelled!');
                    return;
                }
                //console.log(result);
                this.equipmentComponentViewList.push(...result.ResultList);
                this.componentViewDatabase.dataChange.next(this.equipmentComponentViewList);
                this.componentPaginator.length = result.SearchResult.Total;
                this.componentPaginator.pageIndex = pageNo - 1;
                this.componentPaginator.pageSize = pageSize;
                //console.log('component paginator:', this.componentPaginator)
                this.loadSize = pageSize;
                this.ref.detectChanges();
            }, error => { console.log(error); this._loading--; }, () => { this._loading--; }));
    }

    showFilter() {
        this.filterVisible = true;
    }
    rowClicked(event, equipmentId) {
        //console.log(event);
        //if (event.target.className.includes('ignore-click'))
            //return;
        //this.selectedEquipmentId = row.Id;
        //this.selectedEquipmentRow = row;
        //this.viewingEquipmentDetails = true;
        //this._router.navigate(['/equipment', equipmentId]);
        window.open('/equipment/' + equipmentId, '_blank');
    //    this._pref.GetReplaceExistingTabStatus().subscribe(res=>{
    //     if(res=="True"){
    //       this._router.navigate(['/equipment', equipmentId]);
    //     }else{             
    //         window.open('/equipment/' + equipmentId, '_blank');
         
    //     }
    // });
    }

    openEquipmentNewTab(event, equipmentId) {
        event.stopPropagation();
        window.open('/equipment/' + equipmentId, '_blank');
    //    this._pref.GetReplaceExistingTabStatus().subscribe(res=>{
    //     if(res=="True"){
    //       this._router.navigate(['/equipment', equipmentId]);
    //     }else{             
    //         window.open('/equipment/' + equipmentId, '_blank');
         
    //     }
    // });
    }

    componentRowClicked(row: ComponentTableInspectionViewModel) {
        //console.log(row);
        let equipment = new equipmentVwMdl();
        equipment.customerId = row.Equipment.Customer.Id;
        equipment.customerName = row.Equipment.Customer.Title;
        equipment.EvalL = this._appService.getEvalCode(Math.max(...row.Components.filter(m => m.Side == Side.Left).map(m => m.Worn)));
        equipment.EvalR = this._appService.getEvalCode(Math.max(...row.Components.filter(m => m.Side == Side.Right).map(m => m.Worn)));
        equipment.family = row.Equipment.MakeModelFamily.Family.Title;
        equipment.familyId = row.Equipment.MakeModelFamily.Family.Id;
        equipment.Id = row.Equipment.Id;
        equipment.jobsiteId = row.Equipment.JobSite.Id;
        equipment.jobsiteName = row.Equipment.JobSite.Title;
        equipment.lastInspectionDate = this._appService.formatDate(row.LastInspection.Date);
        equipment.lastInspectionId = row.LastInspection.Id;
        equipment.ltd = row.LastInspection.SMU;
        equipment.make = row.Equipment.MakeModelFamily.Make.Title;
        equipment.makeId = row.Equipment.MakeModelFamily.Make.Id;
        equipment.model = row.Equipment.MakeModelFamily.Model.Title;
        equipment.modelId = row.Equipment.MakeModelFamily.Model.Id;
        equipment.overAllEvalNumber = Math.max(...row.Components.map(m => m.Worn));
        equipment.quoteId = 0;
        equipment.serial = row.Equipment.Serial;
        equipment.unit = row.Equipment.Unit;
        equipment.smu = row.Equipment.SMU;
        equipment.quoteId = row.LastInspection.QuoteId;
        this.selectedEquipmentId = equipment.Id;
        this.selectedEquipmentRow = equipment;
        this.viewingEquipmentDetails = true;
    }

    goToOldHistory(Id: number) {
        window.location.href = this.UriConfig.oldUCUri + 'Track/Undercarriagehistory.aspx?equip_auto=' + Id.toString();
    }

    getComponentValue(componentHeader: ComponentColumnHeader, side: Side, components: ComponentViewViewModel[]): string {
        switch (componentHeader) {
            case ComponentColumnHeader.Link:
                return this.getComponentworn(ComponentType.Link, side, components, 0, false).toString();
            case ComponentColumnHeader.Bush:
                return this.getComponentworn(ComponentType.Bushing, side, components, 0, false).toString();
            case ComponentColumnHeader.Shoe:
                return this.getComponentworn(ComponentType.Shoe, side, components, 0, false).toString();
            case ComponentColumnHeader.FrontIdler:
                return this.getComponentworn(ComponentType.Idler, side, components, 1, false).toString();
            case ComponentColumnHeader.RearIdler:
                return this.getComponentworn(ComponentType.Idler, side, components, 2, false).toString();
            case ComponentColumnHeader.Sprocket:
                return this.getComponentworn(ComponentType.Sprocket, side, components, 0, false).toString();
            case ComponentColumnHeader.CarrierRollerAvg:
                return this.getComponentworn(ComponentType.CarrierRoller, side, components, 0, true).toString();
            case ComponentColumnHeader.TrackRollerAvg:
                return this.getComponentworn(ComponentType.TrackRoller, side, components, 0, true).toString();
            case ComponentColumnHeader.TrackRollerWorst:
                return this.getComponentworn(ComponentType.TrackRoller, side, components, 0, true).toString();
            case ComponentColumnHeader.HoursOnLink:
                return this.getComponentLife(ComponentType.Link, side, components, 1).toString();
            case ComponentColumnHeader.BushTurned:
                if (this.checkComponetAction(ComponentType.Bushing, side, components, 1, 12)) //12 = Turn Pins & bushing
                    return this.Translate('Yes');
                return this.Translate('No');
            default:
                return '';
        }
    }

    private getComponentworn(componentType: ComponentType, side: Side, components: ComponentViewViewModel[], position: number, CalcAvg: boolean): number {
        let comps = components.filter(m => m.Compart.CompartType.Id == componentType && m.Side == side);
        if (position != 0)
            comps = comps.filter(m => m.Position == position);
        if (comps.length == 0) return 0;
        if (CalcAvg) {
            var sum = 0;
            for (var i = 0; i < comps.length; i++) {
                sum += comps[i].Worn;
            }
            var avg = sum / comps.length;
            return Math.round(avg * 100) / 100;
        }
        return Math.round(Math.max(...comps.map(m => m.Worn)) * 100) / 100;
    }
    private getComponentLife(componentType: ComponentType, side: Side, components: ComponentViewViewModel[], position: number): number {
        let comp = components.find(m => m.Compart.CompartType.Id == componentType && m.Side == side && m.Position == position);
        if (!comp) return -1;
        return comp.Life;
    }

    getComponentClass(componentHeader: ComponentColumnHeader, side: Side, components: ComponentViewViewModel[]): string {
        let worn = 0;
        switch (componentHeader) {
            case ComponentColumnHeader.Link:
                worn = this.getComponentworn(ComponentType.Link, side, components, 0, false);
                break;
            case ComponentColumnHeader.HoursOnLink:
                return 'hours';
            case ComponentColumnHeader.Bush:
                worn = this.getComponentworn(ComponentType.Bushing, side, components, 0, false);
                break;
            case ComponentColumnHeader.BushTurned:
                return 'actions';
            case ComponentColumnHeader.Shoe:
                worn = this.getComponentworn(ComponentType.Shoe, side, components, 0, false);
                break;
            case ComponentColumnHeader.FrontIdler:
                worn = this.getComponentworn(ComponentType.Idler, side, components, 1, false);
                break;
            case ComponentColumnHeader.RearIdler:
                worn = this.getComponentworn(ComponentType.Idler, side, components, 2, false);
                break;
            case ComponentColumnHeader.Sprocket:
                worn = this.getComponentworn(ComponentType.Sprocket, side, components, 0, false);
                break;
            case ComponentColumnHeader.CarrierRollerAvg:
                worn = this.getComponentworn(ComponentType.CarrierRoller, side, components, 0, true);
                break;
            case ComponentColumnHeader.TrackRollerAvg:
                worn = this.getComponentworn(ComponentType.TrackRoller, side, components, 0, true);
                break;
            case ComponentColumnHeader.TrackRollerWorst:
                worn = this.getComponentworn(ComponentType.TrackRoller, side, components, 0, true);
            case ComponentColumnHeader.OutstandingActions:
                return 'actions';
            case ComponentColumnHeader.Sides:
                return 'label';
            default:
                return 'u-bg';
        }
        if (worn <= 30) return ' a-bg';
        if (worn <= 50) return ' b-bg';
        if (worn <= 70) return ' c-bg';
        return ' x-bg';
    }

    private checkComponetAction(componentType: ComponentType, side: Side, components: ComponentViewViewModel[], position: number, actionTypeId: number): boolean {
        let comp = components.find(m => m.Compart.CompartType.Id == componentType && m.Side == side && m.Position == position);
        if (!comp) return false;
        let action = comp.Actions.find(m => m.ActionType == actionTypeId);
        if (action) return true;
        return false;
    }

    getOutstandingActions(side: Side, components: ComponentViewViewModel[], recommendedActions: ComponentActionViewModel[]): string {
        let comps = components.filter(m => m.Side == side);
        let remainingActions = recommendedActions.length;
        for (let cmp of comps) {
            for (let act of cmp.Actions) {
                if (recommendedActions.findIndex(m => m.ComponentId == cmp.Id && m.ActionType == act.ActionType) >= 0)
                    remainingActions--;
            }
        }
        return remainingActions + '/' + recommendedActions.length;
    }
    mouseClientX: number = 0;
    mouseClientY: number = 0;
    displayActionPopUp: boolean = false;
    actionStatusTable: OutstantingActionStatus[] = [];
    mouseOverAction(event: any, row: ComponentTableInspectionViewModel, side: Side) {
        this.actionStatusTable = [];
        this.actionStatusTable = this.getOutstandingTable(row.Components.filter(m => m.Side == side), row.LastInspection.RecommendedActions);
        if (this.actionStatusTable.length == 0) {
            this.displayActionPopUp = false;
            return;
        }
        this.mouseClientX = event.clientX - 350;
        this.mouseClientY = event.clientY;
        this.displayActionPopUp = true;
    }
    closeActionPopUp() {
        this.actionStatusTable = [];
        this.displayActionPopUp = false;
    }

    private getOutstandingTable(components: ComponentViewViewModel[], actions: ComponentActionViewModel[]): OutstantingActionStatus[] {
        let result: OutstantingActionStatus[] = [];
        //console.log(components, actions);
        for (let action of actions) {
            let current: OutstantingActionStatus = new OutstantingActionStatus();
            current.ComponentId = action.ComponentId;
            current.ActionType = action.ActionType;
            current.ActionTitle = this._appService.getActionTitle(action.ActionType);
            let comp = components.find(m => m.Id == action.ComponentId);
            if (comp && comp.Actions.filter(m => m.ActionType == action.ActionType).length > 0) {
                current.ActionStatus = this.Translate('Done');
                current.CssClass = "action-success";
            } else {
                current.ActionStatus = this.Translate('Outstanding');
                current.CssClass = "action-alert";
            }
            result.push(current);
        }
        return result;
    }

    sortChanged(sort: Sort) {
        if (this._currentSort.active != sort.active)
            this.loadingPage = 1;
        this._currentSort = sort;
        //this.retrieveEquipmentsBySearchItems(this.loadingPage, this.loadSize);
    }

}

///End of component class

export class EqTableDatabase {
    dataChange: BehaviorSubject<equipmentVwMdl[]> = new BehaviorSubject<equipmentVwMdl[]>([]);
    get data(): equipmentVwMdl[] { return this.dataChange.value; }
    constructor(_equipmentList: equipmentVwMdl[]) {
        this.dataChange.next(_equipmentList);
    }
}

export class EqTableDataSource extends DataSource<any> {
    _filterChange = new BehaviorSubject('');
    get filter(): string { return this._filterChange.value; }
    set filter(filter: string) { this._filterChange.next(filter); }
    customerId: number = 0;
    jobsiteId: number = 0;
    equipmentId: number = 0;
    familyId: number = 0;
    makeId: number = 0;
    modelId: number = 0;
    constructor(private _exampleDatabase: EqTableDatabase, private _paginator: MatPaginator) {
        super();
    }
    public selectionUpdated(customer: number, jobsite: number, equipment: number, family: number, make: number, model: number) {
        this.customerId = customer;
        this.jobsiteId = jobsite;
        this.equipmentId = equipment;
        this.familyId = family;
        this.makeId = make;
        this.modelId = model;
    }
    /** Connect function called by the table to retrieve one stream containing the data to render. */
    connect(): Observable<equipmentVwMdl[]> {
        const displayDataChanges = [
            this._exampleDatabase.dataChange,
            this._paginator.page,
            this._filterChange,
        ];

        return Observable.merge(...displayDataChanges).map(() => {
            const data = this._exampleDatabase.data.slice().filter(
                (item: equipmentVwMdl) => {
                    let searchSerial = (item.serial).toLowerCase();
                    let searchUnit = (item.unit).toLowerCase();
                    let searchCustomer = (item.customerName).toLowerCase();
                    let searchMake = (item.make).toLowerCase();
                    let searchModel = (item.model).toLowerCase();
                    let searchFamily = (item.family).toLowerCase();
                    if (this.customerId && item.customerId != this.customerId)
                        return false;
                    if (this.jobsiteId && item.jobsiteId != this.jobsiteId)
                        return false;
                    if (this.equipmentId && item.Id != this.equipmentId)
                        return false;
                    if (this.familyId && item.familyId != this.familyId)
                        return false;
                    if (this.makeId && item.makeId != this.makeId)
                        return false;
                    if (this.modelId && item.modelId != this.modelId)
                        return false;
                    return (searchSerial.indexOf(this.filter.toLowerCase()) != -1
                        || searchUnit.indexOf(this.filter.toLowerCase()) != -1
                        || searchCustomer.indexOf(this.filter.toLowerCase()) != -1
                        || searchMake.indexOf(this.filter.toLowerCase()) != -1
                        || searchModel.indexOf(this.filter.toLowerCase()) != -1
                        || searchFamily.indexOf(this.filter.toLowerCase()) != -1
                    );
                }
            );

            // Grab the page's slice of data.
            //const startIndex = this._paginator.pageIndex * this._paginator.pageSize;
            //return data.splice(startIndex, this._paginator.pageSize);
            return data;
        });
    }

    disconnect() { }
}

export class ComponentViewTableDatabase {
    dataChange: BehaviorSubject<ComponentTableInspectionViewModel[]> = new BehaviorSubject<ComponentTableInspectionViewModel[]>([]);
    get data(): ComponentTableInspectionViewModel[] { return this.dataChange.value; }
    constructor(_equipmentList: ComponentTableInspectionViewModel[]) {
        this.dataChange.next(_equipmentList);
    }
}

export class ComponentViewTableDataSource extends DataSource<any> {
    _filterChange = new BehaviorSubject('');
    get filter(): string { return this._filterChange.value; }
    set filter(filter: string) { this._filterChange.next(filter); }
    constructor(private _componentDatabase: ComponentViewTableDatabase, private _paginator: MatPaginator) {
        super();
    }

    /** Connect function called by the table to retrieve one stream containing the data to render. */
    connect(): Observable<ComponentTableInspectionViewModel[]> {
        const displayDataChanges = [
            this._componentDatabase.dataChange,
            this._paginator.page,
            this._filterChange,
        ];

        return Observable.merge(...displayDataChanges).map(() => {
            const data = this._componentDatabase.data.slice().filter(
                (item: ComponentTableInspectionViewModel) => {
                    let searchSerial = (item.Equipment.Serial).toLowerCase();
                    let searchUnit = (item.Equipment.Unit).toLowerCase();
                    return (searchSerial.indexOf(this.filter.toLowerCase()) != -1
                        || searchUnit.indexOf(this.filter.toLowerCase()) != -1
                    );
                }
            );
            return data;
        });
    }

    disconnect() { }
}
